import config from 'constants/config'
import { useIsDesktopScreen } from 'lib/web/deviceUtils'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'

export function useRenderWhatsApp(region: string) {
  const isDesktop = useIsDesktopScreen()
  return config.WHATS_APP_NUMBER && (!isDesktop || region === 'IN') && isEnabledForFeature(config.WHATS_APP_COUNTRIES, region)
}
